import GameBoard from "./components/gameboard"
function App() {
  return (
    <GameBoard />
  );
}

export default App;
